import React from "react";
import { StarIcon } from "lucide-react";
type StarsProps = {
  className?: string;
};
export function Stars({
  className = ""
}: StarsProps) {
  return <span className={`inline-flex gap-0.5 text-[#d99a19] ${className}`} aria-label="5 de 5 estrellas" data-id="element-312" data-mp="3gqnppxvqi2pv">
      {Array.from({
      length: 5
    }, (_, index) => <StarIcon key={index} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-313" data-mp="3pphs64vqxnbc" />)}
    </span>;
}